import type { HTMLAttributes, ReactNode } from 'react'
import styles from './Typography.module.css'

export interface EyebrowProps extends HTMLAttributes<HTMLElement> {
  tone?: 'muted' | 'brass'
  align?: 'left' | 'center' | 'right'
  as?: 'p' | 'span' | 'div'
  children: ReactNode
}

/* Small uppercase caption: section labels, stat labels, table heads. */
export function Eyebrow({ tone = 'muted', align = 'left', as: Tag = 'p', className, children, ...rest }: EyebrowProps) {
  const cls = [
    styles.eyebrow,
    tone === 'brass' && styles.eyebrowBrass,
    align === 'center' && styles.alignCenter,
    align === 'right' && styles.alignRight,
    className,
  ].filter(Boolean).join(' ')
  return <Tag className={cls} {...rest}>{children}</Tag>
}
